import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import React from "react";
import {getNewAppsInOrg} from "../../../services/Discovery/Discovery";
import {AppDriftGrid} from "../../../components/common/Tables/AppDriftGrid/AppDriftGrid";
import {getGridHeadingCount} from "../../../components/common/Tables/Utilities";

export const NewAppsInOrgPanel = () => {
  const {isLoading, data} = useQueryWithAccessToken({
      queryKey: [cacheKeys.newAppsInOrg],
      queryFunction: getNewAppsInOrg,
      queryFunctionVariables:{}
    }
  );

  return <>
    {
      <AppDriftGrid
        headerName={getGridHeadingCount(data, 'New Apps in Org')}
        shouldShowBackToPrevious={true}
        showAppColumn={true}
        showChangeColumn={false}
        showNewToOrgColumn={false}
        rows={data}
        showUserColumn={true}
        hasUserUrl={true}
        isLoading={isLoading}
      />
    }
  </>;
}